var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from 'axios';
var hostname = window && window.location && window.location.hostname;
var installationhost = 'http://installationsapi.installernet.com/api/';
var environment = 'production';
// determine hosted environment
if (hostname.includes('.sandbox')) {
    environment = 'sandbox';
}
else if (hostname.includes('.staging')) {
    environment = 'staging';
}
else if (hostname.includes('localhost')) {
    environment = 'local';
}
// set api url
if (environment === 'production') {
    installationhost = 'https://installationsapi.installernet.com/api/';
}
else if (environment === 'sandbox') {
    installationhost = 'https://installationsapi.sandbox.installernet.com/api/';
}
else if (environment === 'staging') {
    installationhost = 'https://installationsapi.staging.installernet.com/api/';
}
else if (environment === 'local') {
    installationhost = 'http://installationsapi.staging.installernet.com/api/';
}
console.log("Using " + installationhost + " api");
var authorization = 'd2VhdGhlcmZsb3d1c2VyOlEyM1NiNiph';
var reqHeaders = {
    'Content-Type': 'application/json',
    Authorization: "Basic " + authorization
};
var options = {
    baseURL: "" + installationhost,
    headers: reqHeaders
};
var InstallProperty = /** @class */ (function () {
    function InstallProperty(serviceEventId, property, value) {
        this.propertyId = -1;
        this.serviceEventId = null;
        this.propertyType = null;
        this.serviceEventPropertyValue = null;
        var prop = Installations.propertyIds[property];
        if (prop) {
            this.propertyId = prop.id;
            this.propertyType = prop.type;
            this.serviceEventPropertyValue = value;
            this.serviceEventId = serviceEventId;
        }
    }
    return InstallProperty;
}());
export { InstallProperty };
var Installations = {
    propertyIds: {
        aptCondo: { id: 6, type: null },
        numOfFloors: { id: 59, type: 'General' },
        securityGate: { id: 8, type: null },
        ownProperty: { id: 1254, type: 'General' },
        havePets: { id: 44, type: null },
        homeColor: { id: 43, type: null },
        specialInst: { id: 52, type: null },
        description: { id: 1235, type: 'General' },
        alternateContact: { id: 1255, type: 'General' },
        contactNotes: { id: 1256, type: 'General' },
        textReminder: { id: 1257, type: 'General' }
    },
    getServiceEvent: function (serviceEventId) { return __awaiter(void 0, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, axios.get("serviceevents/" + serviceEventId, options).catch(function (err) { return ({ errorDetail: err }); })];
                case 1:
                    result = _a.sent();
                    if ("errorDetail" in result) {
                        throw result.errorDetail;
                    }
                    return [2 /*return*/, result.data];
            }
        });
    }); },
    getServiceEventDetail: function (serviceEventId) { return __awaiter(void 0, void 0, void 0, function () {
        var se, _a, transaction;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    console.log("Lookup Service Event " + serviceEventId);
                    return [4 /*yield*/, Installations.getServiceEvent(serviceEventId)];
                case 1:
                    se = _b.sent();
                    if (!se.dateIssued) return [3 /*break*/, 4];
                    console.log('Retrieved service event');
                    _a = se;
                    return [4 /*yield*/, Installations.getContact(serviceEventId).catch(function (e) {
                            console.log("No customer information for service event: " + e);
                        })];
                case 2:
                    _a.customer = _b.sent();
                    return [4 /*yield*/, Installations.getServiceEventTransaction(serviceEventId).catch(function (e) {
                            console.log("No transaction for service event: " + e);
                        })];
                case 3:
                    transaction = _b.sent();
                    if (transaction.length > 0) {
                        se.transaction = transaction[0];
                    }
                    return [3 /*break*/, 5];
                case 4:
                    console.log("Service Event not found");
                    return [2 /*return*/, null];
                case 5: 
                // This will cause compoenent refresh so no code should happen after
                return [2 /*return*/, se];
            }
        });
    }); },
    createServiceEvent: function (request) { return __awaiter(void 0, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, axios.post('serviceevents', request, options).catch(function (err) { return ({ errorDetail: err }); })];
                case 1:
                    result = _a.sent();
                    if ("errorDetail" in result) {
                        throw result.errorDetail;
                    }
                    return [2 /*return*/, result.data];
            }
        });
    }); },
    getServiceEventItems: function (serviceEventId) { return __awaiter(void 0, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, axios.get("serviceevents/" + serviceEventId + "/items", options).catch(function (err) { return ({ errorDetail: err }); })];
                case 1:
                    result = _a.sent();
                    if ("errorDetail" in result) {
                        throw result.errorDetail;
                    }
                    return [2 /*return*/, result.data];
            }
        });
    }); },
    getServiceEventTransaction: function (serviceEventId) { return __awaiter(void 0, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, axios.get("serviceevents/" + serviceEventId + "/transactions", options).catch(function (err) { return ({ errorDetail: err }); })];
                case 1:
                    result = _a.sent();
                    if ("errorDetail" in result) {
                        throw result.errorDetail;
                    }
                    return [2 /*return*/, result.data];
            }
        });
    }); },
    saveServiceEventTransaction: function (serviceEventId, customer) { return __awaiter(void 0, void 0, void 0, function () {
        var transaction, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    transaction = {
                        serviceEventId: serviceEventId,
                        transactionDate: new Date(Date.now()).toLocaleString(),
                        transactionType: 'SALE',
                        customerName: customer.firstName + " " + customer.lastName,
                        company: customer.company,
                        address: customer.address,
                        address2: customer.address2,
                        city: customer.city,
                        state: customer.state,
                        zipCode: customer.zipCode,
                        phoneNumber: customer.phoneNumber,
                        email: customer.email
                    };
                    return [4 /*yield*/, axios.post("serviceevents/" + serviceEventId + "/transactions", transaction, options).catch(function (err) { return ({ errorDetail: err }); })];
                case 1:
                    result = _a.sent();
                    if ("errorDetail" in result) {
                        throw result.errorDetail;
                    }
                    return [2 /*return*/, result.data];
            }
        });
    }); },
    getContact: function (serviceEventId) { return __awaiter(void 0, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    // get customer
                    console.log('getting customer');
                    return [4 /*yield*/, axios.get("serviceevents/" + serviceEventId + "/contact", options).catch(function (err) { return ({ errorDetail: err }); })];
                case 1:
                    result = _a.sent();
                    if ("errorDetail" in result) {
                        throw result.errorDetail;
                    }
                    return [2 /*return*/, result.data];
            }
        });
    }); },
    saveContact: function (contact) { return __awaiter(void 0, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    console.log('saving customer');
                    return [4 /*yield*/, axios.put("serviceevents/" + contact.serviceEventId + "/contact", contact, options).catch(function (err) { return ({ errorDetail: err }); })];
                case 1:
                    result = _a.sent();
                    console.log(result);
                    if ("errorDetail" in result) {
                        throw result.errorDetail;
                    }
                    return [2 /*return*/, result.data];
            }
        });
    }); },
    getServiceEventProducts: function (serviceEventId) { return __awaiter(void 0, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, axios.get("serviceevents/" + serviceEventId + "/products", options).catch(function (err) { return ({ errorDetail: err }); })];
                case 1:
                    result = _a.sent();
                    if ("errorDetail" in result) {
                        throw result.errorDetail;
                    }
                    return [2 /*return*/, result.data];
            }
        });
    }); },
    removeServiceEventProduct: function (serviceEventId, serviceEventProductId) { return __awaiter(void 0, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    console.log("Removing product " + serviceEventProductId + " for service event " + serviceEventId);
                    return [4 /*yield*/, axios.delete("serviceevents/" + serviceEventId + "/products/" + serviceEventProductId, options).catch(function (err) { return ({ errorDetail: err }); })];
                case 1:
                    result = _a.sent();
                    if ("errorDetail" in result) {
                        throw result.errorDetail;
                    }
                    return [2 /*return*/, result.data];
            }
        });
    }); },
    addServiceEventProduct: function (serviceEventId, productId, instance) { return __awaiter(void 0, void 0, void 0, function () {
        var body, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    console.log("Adding product " + productId + " for service event " + serviceEventId);
                    body = {
                        serviceEventId: serviceEventId,
                        productBrand: 'Delos',
                        productId: productId,
                        instance: instance
                    };
                    return [4 /*yield*/, axios.post("serviceevents/" + serviceEventId + "/products", body, options).catch(function (err) { return ({ errorDetail: err }); })];
                case 1:
                    result = _a.sent();
                    if ("errorDetail" in result) {
                        throw result.errorDetail;
                    }
                    return [2 /*return*/, result.data];
            }
        });
    }); },
    getServiceEventStatus: function (serviceEventId) { return __awaiter(void 0, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, axios.get("serviceevents/" + serviceEventId + "/status", options).catch(function (err) { return ({ errorDetail: err }); })];
                case 1:
                    result = _a.sent();
                    if ("errorDetail" in result) {
                        throw result.errorDetail;
                    }
                    return [2 /*return*/, result.data];
            }
        });
    }); },
    activateServiceEvent: function (serviceEventId) { return __awaiter(void 0, void 0, void 0, function () {
        var status, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    status = {
                        serviceEventID: serviceEventId,
                        status: 'Active'
                    };
                    return [4 /*yield*/, axios.post("serviceevents/" + serviceEventId + "/status", status, options).catch(function (err) { return ({ errorDetail: err }); })];
                case 1:
                    result = _a.sent();
                    if ("errorDetail" in result) {
                        throw result.errorDetail;
                    }
                    return [2 /*return*/, result.data];
            }
        });
    }); },
    getProgramProducts: function (programId) { return __awaiter(void 0, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, axios.get("programproducts?filter=programid=" + programId, options).catch(function (err) { return ({ errorDetail: err }); })];
                case 1:
                    result = _a.sent();
                    if ("errorDetail" in result) {
                        throw result.errorDetail;
                    }
                    return [2 /*return*/, result.data];
            }
        });
    }); },
    getServiceEventProperties: function (serviceEventId) { return __awaiter(void 0, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, axios.get("serviceevents/" + serviceEventId + "/properties", options).catch(function (err) { return ({ errorDetail: err }); })];
                case 1:
                    result = _a.sent();
                    if ("errorDetail" in result) {
                        throw result.errorDetail;
                    }
                    return [2 /*return*/, result.data];
            }
        });
    }); },
    updateServiceEventProperties: function (serviceEventId, properties) { return __awaiter(void 0, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, axios.put("serviceevents/" + serviceEventId + "/properties", properties, options).catch(function (err) { return ({ errorDetail: err }); })];
                case 1:
                    result = _a.sent();
                    if ("errorDetail" in result) {
                        throw result.errorDetail;
                    }
                    return [2 /*return*/, result.data];
            }
        });
    }); },
    getSchedule: function (serviceEventId) { return __awaiter(void 0, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, axios.get("serviceevents/" + serviceEventId + "/schedule", options).catch(function (err) { return ({ errorDetail: err }); })];
                case 1:
                    result = _a.sent();
                    if ("errorDetail" in result) {
                        throw result.errorDetail;
                    }
                    return [2 /*return*/, result.data];
            }
        });
    }); },
    setSchedule: function (schedule) { return __awaiter(void 0, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, axios.put("serviceevents/" + schedule.serviceEventId + "/schedule", schedule, options).catch(function (err) { return ({ errorDetail: err }); })];
                case 1:
                    result = _a.sent();
                    if ("errorDetail" in result) {
                        throw result.errorDetail;
                    }
                    return [2 /*return*/, result.data];
            }
        });
    }); }
};
export default Installations;
